module.exports = __webpack_public_path__ + "img/scatter.32fbbcd5.png";